const cookieManagerConfig = {
  categories: [{
    id: 'necessary',
    required: true,
    trackers: [{
      id: '__cfduid',
      // Used for security, maintained by Cloudflare
      type: 'cookie'
    }, {
      id: 'cb_dm',
      // Coinbase Device marker, used to identify user's device
      type: 'cookie'
    }, {
      id: '__cfruid',
      // Cloudfare load-balancing, deliverance of website content, and serving DNS connections
      type: 'cookie'
    }, {
      id: 'oauth-state-cookie',
      // Used for authentication
      type: 'cookie'
    }, {
      id: 'ip_country',
      // Used to determine which country a given ip address is from
      type: 'cookie'
    }, {
      id: '_cfuvid',
      // Allow the Cloudflare to distinguish individual users who share the same IP address
      type: 'cookie'
    }, {
      id: 'cds-ffs',
      // Coinbase CDS FeatureFlagProvider that allows us to configure which feature flags are turned on via a the 'cds-ffs' cookie. Users will only have access to specific features under the flag.
      type: 'cookie'
    }, {
      id: 'cc_dashboard_session',
      // Session token used to see if we already have a valid login session for current user. This is necessary for users to login.
      type: 'cookie'
    }, {
      id: 'cc_locale_flag',
      // Get locale for user for translations, e.g en-US. This remembers preset locale languge for personalization.
      type: 'cookie'
    }, {
      id: 'logged_in',
      // Used for routing users
      type: 'cookie'
    }, {
      id: 'cb-gssc_development',
      // Used as a session sync cookie
      type: 'cookie'
    }, {
      id: 'cb-gssc_staging',
      // Used as a session sync cookie
      type: 'cookie'
    }, {
      id: 'cb-gssc',
      // Used as a session sync cookie
      type: 'cookie'
    }, {
      id: '_coinbase_session',
      // Used for security
      type: 'cookie'
    }, {
      id: 'advertising_sharing_allowed',
      // Used for Privacy
      type: 'cookie'
    }, {
      id: '__ssid',
      // Used for security
      type: 'cookie'
    }, {
      id: 'cf_ob_info',
      // Used for security
      type: 'cookie'
    }, {
      id: 'df2',
      // Used for security and fraud
      type: 'cookie'
    }, {
      id: 'df',
      // Used for security and fraud
      type: 'cookie'
    }, {
      id: 'ba',
      // Used for security and fraud
      type: 'cookie'
    }, {
      id: 'cf_use_ob',
      // Used for security
      type: 'cookie'
    }, {
      id: '_coinbase_lax',
      // Used for security
      type: 'cookie'
    }, {
      id: '_coinbase_strict',
      // Used for security
      type: 'cookie'
    }, {
      id: 'jwt',
      // Used for authentication
      type: 'cookie'
    }, {
      id: 'unified-session-manager-cookie',
      // Used for authentication
      type: 'cookie'
    }, {
      id: 'sft',
      // Used for second factor security
      type: 'cookie'
    }, {
      id: 'japan_bespoke_content',
      // Used for japan testing
      type: 'cookie'
    }, {
      id: 'utm',
      // Used for attributing paid marketing
      type: 'cookie'
    }, {
      id: 'utm_raw',
      // Used for attributing paid marketing
      type: 'cookie'
    }, {
      id: 'user_agent',
      // Used for attributing paid marketing
      type: 'cookie'
    }, {
      id: '__cf_bm',
      // This cookie is necessary for the proper functioning of bot solutions, that identify and mitigate automated traffic to protect your site from bad bots. This cookie lasts 1 session
      // Source: https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies
      type: 'cookie'
    }, {
      id: 'CB-CLIENT',
      // Persists the CB-CLIENT header for use in webviews; identifies the
      // mobile app the request comes from and the version of that app.
      type: 'cookie'
    }, {
      id: 'cb_test_cookie',
      // Used to test if cookies are enabled in browser
      type: 'cookie'
    }, {
      id: 'is_mobile_app',
      // Required for the mobile app to communicate its cookie policy.
      type: 'cookie'
    }]
  }, {
    id: 'performance',
    trackers: [{
      id: 'cb-rfm',
      // Used to for consistent DB reads
      type: 'cookie'
    }, {
      id: 'ajs_anonymous_id',
      // These cookies are generally used for Analytics and help count how many people visit a certain site by tracking if you have visited before. This cookie has a lifespan of 1 year.
      type: 'cookie'
    }, {
      id: '__tld__',
      // Usage Trends
      type: 'cookie'
    }, {
      id: 'ajs%3Acookies',
      // This cookie supports use, service performance, and functionality of websites. Cookies in this domain have lifespan of 1 year.',
      type: 'cookie'
    }, {
      id: 'ajs%3Atest',
      // This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
      type: 'cookie'
    }, {
      id: 'ajs_group_id',
      // These cookies track visitor usage and events within the website. Cookies in this domain have lifespan of 1 year.',
      type: 'cookie'
    }, {
      id: 'coinbase_device_id',
      // Used for experimentation bucketing
      type: 'cookie'
    }, {
      id: 'amplitude_device_id',
      // Used for experimentation bucketing (deprecated)
      type: 'cookie'
    }, {
      id: '_gat',
      // This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites. It expires after 10 minutes.',
      type: 'cookie'
    }, {
      id: '_gac_UA-regex',
      // This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
      type: 'cookie',
      regex: '_gac_UA-[0-9]+-[0-9]+'
    }, {
      id: '_ga_regex',
      // This cookie name is associated with Google Analytics (GA + web tag), according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
      type: 'cookie',
      regex: '_ga_[a-zA-Z0-9]{10}'
    }, {
      id: '_gid',
      // This cookie name is asssociated with Google Universal Analytics. This appears to be a new cookie and as of Spring 2017 no information is available from Google.  It appears to store and update a unique value for each page visited.
      type: 'cookie'
    }, {
      id: '_ga',
      // This cookie name is associated with Google Universal Analytics - which is a significant update to Google's more commonly used analytics service. This cookie is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session and campaign data for the sites analytics reports.  By default it is set to expire after 2 years, although this is customisable by website owners.
      type: 'cookie'
    }, {
      id: 'JSESSIONID',
      // This domain is controlled by New Relic, which provides a platform for monitoring the performance of web and mobile applications.
      type: 'cookie'
    }, {
      id: 'cf_chl_rc_i',
      // This cookie is for internal use which allows Cloudflare to identify production issues on clients. This cookie has a lifespan of 1 session.
      // Source: https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies
      type: 'cookie'
    }, {
      id: 'dtcookie',
      // This cookie is used to identify user sessions. This cookie is valid as long as the browser process is running.
      // Source: https://www.dynatrace.com/support/doc/appmon/user-experience-management/user-experience-management-administration/firewall-constraints-for-uem/
      type: 'cookie'
    }, {
      id: 'perf_dv5',
      // This cookie contains information to help distinguish users from the page. Gathers data about user visits, such as which pages are relevant. This cookie lasts 1 day
      // Source: http://www.allreballing.it/privacy-cookie/
      type: 'cookie'
    }, {
      id: 'rl_anonymous_id',
      // This cookie stores rl_anonymous_id , and attaches to every subsequent event. Helps identify users from other sites that hosted under a sub-domain. This cookie lasts 1 year
      // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/sdk-faqs
      type: 'cookie'
    }, {
      id: 'rl_user_id',
      // This cookie stores user with your application's unique identifier like email, database ID etc and  attaches to every event. This cookie lasts 1 year.
      // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/rudderstack-javascript-sdk
      type: 'cookie'
    }, {
      id: 'rl_group_id',
      // This cookie collects user activity on the web. This cookie lasts 1 year.
      // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/rudderstack-javascript-sdk
      type: 'cookie'
    }, {
      id: 'AMCV_regex',
      // This cookie stores a unique visitor ID and lets the ID service track visitors across your different domains and enable data sharing among different Experience Cloud solutions. This cookie expires after 2 years.
      // Source: https://experienceleague.adobe.com/docs/core-services/interface/administration/ec-cookies/cookies-mc.html?lang=en
      type: 'cookie',
      regex: 'AMCV_(?:[0-9A-Z]+)@AdobeOrg'
    }, {
      id: 'LPVID',
      // This cookie prvides a visitor ID as identified in Conversational Cloud. Identifies a browser as long as cookie is not deleted. This cookie lasts 1 year.
      //Source: https://developers.liveperson.com/cookies-and-conversational-cloud-overview.html
      type: 'cookie'
    }, {
      id: '__profilin',
      // Developer only, used by rack-mini-profiler to bypass work. This cookie lasts for the session.
      // Source: https://www.rubydoc.info/gems/rack-mini-profiler/0.9.6/Rack/MiniProfiler/ClientSettings
      type: 'cookie'
    }, {
      id: 'amp_regex',
      // This cookie is used to keep track of a few bits of metadata for the SDK: A randomly generated device id, the current session id, the current user id if a user id is set, the last event time, a few sequence ids in order to sequence events and identifies correctly
      // Source: https://developers.amplitude.com/docs/advanced-settings
      type: 'cookie',
      regex: 'amp_[0-9a-z]{6}'
    }, {
      id: 'LPSID-regex',
      // This cookie tracks the current active (or last) monitoring session. This cookie lasts a session.
      // Source: https://developers.liveperson.com/cookies-and-conversational-cloud-overview.html
      type: 'cookie',
      regex: 'LPSID-[0-9]+'
    }, {
      id: '_hp2_id.regex',
      // This cookie collects information to measure and understand how visitors use our Site. This includes user activity tracking on this Site, including pages visited and links clicked. This cookie lasts 1 day - 2 years.
      // Source: https://help.heap.io/data-privacy/data-privacy-faqs/what-cookies-does-heap-set-and-what-are-they-used-for/
      type: 'cookie',
      regex: '_hp2_id.[0-9]+'
    }, {
      id: '__utma',
      // This cookie is used to distinguish users and sessions. The cookie is created when the javascript library executes and no existing __utma cookies exists. The cookie is updated every time data is sent to Google Analytics. This cookie lasts 2 years.
      // Source: https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
      type: 'cookie'
    }, {
      id: 'x-login-id',
      // Persisted header in webviews. Tracks specific login attempts and is
      // used to correlate logs. It is short lived and renewed with each
      // login attempt.
      type: 'cookie'
    }, {
      id: 'x-uuid',
      // Persisted header in webviews. Device identifier for login purpose.
      // Likely to be cleaned up in the future when we have a clearer
      // strategy on that since other cookies like cb-fp2 serve a similar
      // purpose.
      type: 'cookie'
    }]
  }, {
    id: 'functional',
    trackers: [{
      id: '_parsely_visitor',
      // This cookie is used to determine if the visitor has visited the website before, or if it is a new visitor on the website.
      type: 'cookie'
    }, {
      id: 'advanced_color_theme',
      // Used to remember the theme preference of a user in advanced mode.
      type: 'cookie'
    }, {
      id: 'hide_advanced_mode_nux',
      // Used to remember if the user dismissed the Advanced mode NUX modal
      type: 'cookie'
    }, {
      id: 'futures_hide_first_trade_onboarding_spotlight',
      // This cookie is used to track if the user has seen the first trade onboarding spotlight
      type: 'cookie'
    }, {
      id: 'futures_hide_after_first_trade_spotlight',
      // This cookie is used to track if the user has seen the after first trade spotlight
      type: 'cookie'
    }, {
      id: 'has_seen_perpetual_margin_health_banner_regex',
      type: 'cookie',
      regex: 'has_seen_perpetual_margin_health_banner_(.*)'
    }, {
      id: 'has_seen_advanced_mode_tooltip',
      // Used to determine whether to show an advanced mode user how to toggle between simple --> advanced
      type: 'cookie'
    }, {
      id: 'hide_usdc_banner',
      // Used to determine if the user dismissed the Trade with USDC banner on the Market Selector
      type: 'cookie'
    }, {
      id: 'has_seen_order_form_nux_tooltip',
      // Used to remember if the user has seen the tooltip explaining the changed order form options.
      type: 'cookie'
    }, {
      id: 'has_seen_advanced_fees_pricing_banner',
      // Used to determine whether an eligible advanced trader should be shown a banner elucidating a new fee structure

      type: 'cookie'
    }, {
      id: 'has_seen_zero_fee_incentive_banner',
      // Short term cookie being used to prevent upsell from display again after dismissed. For future projects, team has been alerted to use the upsell framework instead.
      type: 'cookie'
    }, {
      id: 'has_submitted_prime_resources_interest_form',
      // Used to determine whether a user has submitted prime resources interest form.
      type: 'cookie'
    }, {
      id: 'has_submitted_leadgen_form',
      // Used to determine whether a user has submitted leadgen form.
      type: 'cookie'
    }, {
      id: 'price_chart_resolution',
      // Used to preserve the user's trading view on Advanced Trade, also used to allow for prefetching some requests regarding the price chart
      type: 'cookie'
    }, {
      id: 'optimizelyEndUserId',
      // Optimizely places this for web experimentation and personalization',
      type: 'cookie'
    }, {
      id: 'coinbase_locale',
      // Used for persisting customer locale. Sets default locale/language',
      type: 'cookie'
    }, {
      id: 'cb_logged_out_locale',
      // Used for persisting logged out customer locale. Sets default logged out locale (language-country)',
      type: 'cookie'
    }, {
      id: 'coinbase_currency',
      // Used for persisting customer's preferred fiat currency.
      type: 'cookie'
    }, {
      id: 'hide_country_banner',
      // Used to check if country banner has been dismissed',
      type: 'cookie'
    }, {
      id: 'hide_cookies_message',
      // This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
      type: 'cookie'
    }, {
      id: 'hide_android_banner',
      // For hiding the android banner
      type: 'cookie'
    }, {
      id: 'plaid_oauth_data',
      // Used to identify returning users during the Plaid oauth flow
      type: 'cookie'
    }, {
      id: 'bytes_signup_modal_viewed',
      // determines if the user has already seen the global bytes signup modal
      type: 'cookie'
    }, {
      id: 'cached_locale',
      // Used to speed up app loading time
      type: 'cookie'
    }, {
      id: 'rlm_asset_page_view_count',
      // Keeps count of the asset page views which is used for the asset page rate limit modal
      type: 'cookie'
    }, {
      id: 'rlm_home_page_view_count',
      // Keeps count of the asset page views which is used for the home page rate limit modal
      type: 'cookie'
    }, {
      id: 'rlm_converter_page_view_count',
      // Keeps count of the converter page views which is used for the converter page rate limit modal
      type: 'cookie'
    }, {
      id: 'rlm_dismissed_asset',
      // Used to track if a user has dismissed the rate limit modal on the asset page
      type: 'cookie'
    }, {
      id: 'rlm_dismissed_home',
      // Used to track if a user has dismissed the rate limit modal on the home page
      type: 'cookie'
    }, {
      id: 'rlm_dismissed_converter',
      // Used to track if a user has dismissed the rate limit modal on the converter page
      type: 'cookie'
    }, {
      id: 'signup_modal_dismissed_home',
      // determines if the user has dismissed the signup modal on home page
      type: 'cookie'
    }, {
      id: 'signup_modal_dismissed_learn',
      // determines if the user has dismissed the signup modal on learn page
      type: 'cookie'
    }, {
      id: 'has_seen_fee_upgrade_banner',
      // Used to track if the user has already seen and dismissed the fee upgrade banner
      type: 'cookie'
    }, {
      id: 'paypal_reauth_data',
      // Used to identify returning users during the Paypal reauth flow
      type: 'cookie'
    }, {
      id: 'cb-sut',
      // Magic cookie for smart routing on staging and dev to fetch frontend build from candidate s3 bucket instead of canonical dev or staging s3 bucket
      type: 'cookie'
    }, {
      id: 'hide_hc_country_banner',
      // Used to check if country banner has been dismissed',
      type: 'cookie'
    }]
  }, {
    id: 'targeting',
    trackers: [{
      id: 'li_fat_id',
      // This cookie is used to pass back conversion events to LinkedIn after user goes through Unified Signup.
      type: 'cookie'
    }, {
      id: 'rdt_cid',
      // This cookie is used to pass back conversion events to Reddit after user goes through Unified Signup.
      type: 'cookie'
    },
    // First party
    {
      id: 'gclid',
      // Used for attributing Google marketing
      type: 'cookie'
    }, {
      id: '_uetvid',
      // Store and track activity across websites
      type: 'cookie'
    }, {
      id: '_uetsid',
      // Store and track activity across websites
      type: 'cookie'
    }, {
      id: 'MUID',
      // Store and track activity across websites
      type: 'cookie'
    }, {
      id: 'fbclid',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: '_gat_gtag_',
      // Google Analytics
      type: 'cookie'
    }, {
      id: '_gat_gtag_UA_-regex',
      // Google Analytics, used for storing unique user id.
      type: 'cookie',
      regex: '_gat_gtag_UA_[0-9]+_[0-9]+'
    }, {
      id: '_gcl_au',
      // Used by google tag manager
      type: 'cookie'
    },
    // Third party
    {
      id: '_fbc',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: '_fbp',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'wd',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'dpr',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'act',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'c_user',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'presence',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'sb',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'xs',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'spin',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'datr',
      // Used for attributing Facebook marketing
      type: 'cookie'
    }, {
      id: 'YSC',
      // YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
      type: 'cookie'
    }, {
      id: 'VISITOR_INFO1_LIVE',
      // This cookie is ownded by Youtube and used as a unique identifier to track viewing of videos',
      type: 'cookie'
    }, {
      id: 'amplitude_id-regex',
      type: 'cookie',
      // This cookie is from Amplitude for tracking users
      regex: 'amplitude_id(?:_[a-f0-9]{32}|undefined)(?:.*)'
    }, {
      id: 'ATN',
      // This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
      type: 'cookie'
    }, {
      id: 'NID',
      // This domain is owned by Google Inc. Although Google is primarily known as a search engine, the company provides a diverse range of products and services. Its main source of revenue however is advertising. Google tracks users extensively both through its own products and sites, and the numerous technologies embedded into many millions of websites around the world. It uses the data gathered from most of these services to profile the interests of web users and sell advertising space to organisations based on such interest profiles as well as aligning adverts to the content on the pages where its customer's adverts appear.",
      type: 'cookie'
    }, {
      id: 'GPS',
      // YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
      type: 'cookie'
    }, {
      id: 'AA003',
      // This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
      type: 'cookie'
    }, {
      id: '_gat_UA-regex',
      type: 'cookie',
      // This cookie name is associated with Google Universal Analytics, according to documentation it is used for statistics.',
      regex: '_gat_UA-([0-9]{8})-([0-9]{2})'
    }, {
      id: 'mp_regex',
      type: 'cookie',
      // Cookie is placed by Mixpanel. Mixpanel is a company that produces user behavior analytics.',
      regex: 'mp_[a-f0-9]{32}_mixpanel'
    }, {
      id: 'gcl',
      // Ads targeting for Google and conversion tracking
      type: 'cookie'
    }, {
      id: 'msclkid',
      // Ads targeting for Microsoft and conversion tracking
      type: 'cookie'
    }, {
      id: 'ptclid',
      // Ads targeting for Pinterest and conversion tracking
      type: 'cookie'
    }, {
      id: 'ttclid',
      // Ads targeting for TikTok and conversion tracking
      type: 'cookie'
    }, {
      id: '_gcl_aw',
      // This cookie functions to store ad click information (only if remarketing cookies are enabled), generate unique IDs for visitors to remember preferences and track and gather statistics and conversion rates through the website. It expires after 90 days.
      // Source: https://support.google.com/tagmanager/answer/7549390?hl=en
      type: 'cookie'
    }, {
      id: 'iterableTemplateId',
      // This cookie contains a unique ID associated with the email's template in Iterable. This cookie expires in one day.
      // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
      type: 'cookie'
    }, {
      id: 'iterableMessageId',
      // This cookie contains a unique ID associated with a specific send of a specific Iterable campaign to a specific user. If the same user ever receives the same campaign more than once, each will have a unique iterableMessageId. This cookie expires in one day.
      //Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
      type: 'cookie'
    }, {
      id: 'iterableEndUserId',
      // This cookie contains the recipient's e-mail address. This cookie expires in one day.
      // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
      type: 'cookie'
    }, {
      id: 'iterableEmailCampaignId',
      // This cookie contains a unique ID associated with the email's campaign in Iterable. This cookie expiresin one day.
      // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
      type: 'cookie'
    }, {
      id: '_gac_gb_regex',
      // This cookie contains campaign related information. This cookie exists for 90 days.
      // Source: https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
      type: 'cookie',
      regex: '_gac_gb_[0-9A-Z-]+'
    }]
  }, {
    id: 'delete-if-seen',
    trackers: [{
      id: 'cloudflare-challenge-regex',
      type: 'cookie',
      // These cookies are used by Cloudflare for the execution of
      // Javascript or Captcha challenges. They are not used for tracking or
      // beyond the scope of the challenge. They can be deleted if seen.
      regex: '^(cf_chl_prog$)|(cf_cc_...$)|(cf_chl_cc_...$)|(cf_chl_seq_...$)'
    }]
  }],
  geolocationRules: [{
    region: 'DEFAULT',
    framework: 'optOut'
  }, {
    region: 'EU',
    framework: 'optIn'
  }]
};
export { cookieManagerConfig };
//# sourceMappingURL=cookieManagerConfig.js.map
